<template>
    <form class="form" :action="endpoint" method="POST" enctype="multipart/form-data">
        <input type="hidden" name="_token" :value="csrfToken">
        <input type="hidden" name="formId" :value="formId">
        <div class="row">
            <Field v-for="fieldId in fieldsOrder" :key="fieldId" :fieldId="fieldId" />
        </div>
        <input class="btn btn-default" type="submit" value="Envoyer">
    </form>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import Field from './form/Field.vue';

    export default {
        name: 'page-builder',
        components: {
            Field,
        },
        computed: {
            ...mapState([ 'fieldsOrder', 'csrfToken', 'endpoint', "formId" ]),
        },
        methods: {},
    }
</script>

<style lang="scss" scoped>
</style>
